module.exports = __webpack_public_path__ + "static/media/BodyPostureFeedbackGRE.13e68996.vtt";